export var defaultProps = {
    className: '',
    bgColor: 'dark',
    defaultSelectedKey: '',
    defaultOpenKeys: [],
    userInfo: '',
    title: null,
    icon: null,
    isHorizontal: false,
    onClickMenu: function (key, openKeys) { },
    onChangeSelect: function (key) { },
    onChangeOpen: function (keys) { },
};
